import {useMutation, useQueryClient} from "@tanstack/react-query";
import {useModal} from "../../../../../hooks";
import {AxiosError} from "axios";
import {deleteShipment} from "../../../../../api/order/OrdersApi";


export const useDeleteShipment = ({closeCallback}: { closeCallback: () => any }) => {
    const {handleModal} = useModal();
    const qc = useQueryClient()

    const {mutate} = useMutation({
        mutationFn: (data: { id: string }[]) => deleteShipment(data),
        onSuccess: () => {
            handleModal({
                isOpen: true,
                contents: "삭제되었습니다",
                type: "alert",
                closeAction: () => {
                    qc.invalidateQueries({queryKey: ["readShipmentList"]})
                    closeCallback()
                }
            });
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate};
};
